module.exports = __webpack_public_path__ + "img/feature-mobile-service.caa08cea.jpg";